import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuexI18n from 'vuex-i18n'
import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
import VTree from 'vue-tree-halower'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-awesome/icons/flag'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

import { translationsEn } from './store/i18n/en'
import { translationsTh } from './store/i18n/th'

Vue.config.productionTip = false

Vue.use(VTree)
Vue.use(vuexI18n.plugin, store)
Vue.use(BootstrapVue)
Vue.component('icon', Icon)

Vue.i18n.add('en', translationsEn)
Vue.i18n.add('th', translationsTh)
Vue.i18n.set('th')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
